export default __webpack_public_path__ + "static/media/CNo.18-1.21ef0602.jpg";